import { matchPath, useLocation, useNavigate } from 'react-router-dom'

import { AntTab, AntTabs } from 'common/components/AntTabs'

/**
 * Shared / Personal tab navigation for data view
 *
 * TODO: figure out base path
 * @param dataViewBasePath
 * @returns toggle component
 *
 */

const ImportExportTab = () => {
  enum importExportType {
    import = 'import',
    export = 'export'
  }

  // TODO: [FE DEBT] update importExportBasePath path
  const importExportBasePath = 'data-management/import-export'

  // Feature flag (Vite)
  const ENABLE_EXPORT_ONLY =
    import.meta.env.VITE_ENABLE_DATA_EXPORT_ONLY?.toLowerCase() === 'true'

  const navigate = useNavigate()
  const { pathname, search } = useLocation()

  const pathMatch = matchPath(`/${importExportBasePath}/:tabView`, pathname)

  let selectedView: importExportType = importExportType.export

  const urlTab = pathMatch?.params?.tabView as importExportType | undefined

  if (
    urlTab === importExportType.import ||
    urlTab === importExportType.export
  ) {
    selectedView = urlTab
  }

  // Tabs list depends on flag
  const tabs = ENABLE_EXPORT_ONLY
    ? [importExportType.export]
    : [importExportType.import, importExportType.export]

  // Selected index based on current selectedView (falls back to 0)
  const selectedIndex = Math.max(tabs.indexOf(selectedView), 0)

  // Redirect to export if only export is enabled and user is on import tab
  if (ENABLE_EXPORT_ONLY && selectedView === importExportType.import) {
    const tabView = tabs[0]
    navigate(`/${importExportBasePath}/${tabView}${search}`)
  }

  const handleTabSelect = (_event: React.SyntheticEvent, idx: number): void => {
    const tabView = tabs[idx]
    navigate(`/${importExportBasePath}/${tabView}${search}`)
  }

  return (
    <AntTabs
      value={selectedIndex}
      onChange={handleTabSelect}
      sx={{ maxHeight: '40px', minHeight: 'unset' }}
    >
      {!ENABLE_EXPORT_ONLY && (
        <AntTab label='IMPORT' sx={{ maxHeight: '40px', minHeight: 'unset' }} />
      )}
      <AntTab label='EXPORT' sx={{ maxHeight: '40px', minHeight: 'unset' }} />
    </AntTabs>
  )
}

export default ImportExportTab
